module.exports = __webpack_public_path__ + "img/icn-filter-08.8eab137b.svg";